module.exports = __webpack_public_path__ + "static/media/key.5f64dae3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/key.svg
// module id = 338
// module chunks = 0